import { useTranslation } from 'react-i18next';

interface Props {
  msgKey: string;
  args?: any[];
  class?: string;
}

const I18nSpan = ({ msgKey, args, class: className }: Props) => {
  const { t } = useTranslation();

  return (
    <span className={className}>
      {t(msgKey, {
        ...(Array.isArray(args) && { ...args })
      })}
    </span>
  );
};

export default I18nSpan;
